// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Layout-CssProp6_main-astroturf-module--cls1--3hC20","cls2":"Layout-CssProp6_main-astroturf-module--cls1--3hC20 Layout-CssProp6_main-astroturf-module--cls2--aeTps"};